import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { STATIONLIST } from "../../Utils/conts";
import { createBaseQueryWithReauth } from "../../Services/Basequerywithreauth";

export const airlineService = createApi({
    reducerPath: "airlineService",
    baseQuery: createBaseQueryWithReauth(),
    endpoints: (builder) => ({
        getOverview: builder.query({
            query: (params) => ({
                url: 'v2/service-recovery/list',
                params,
            }),
        }),
        getStationSettings: builder.query({
            query: (params) => ({
                url: STATIONLIST,
                params,
            }),
        }),
        getStationSettingsDetail: builder.query({
            query: (params) => ({
                url: "station-details",
                params,
            }),
        }),
        regions: builder.query({
            query: (params) => ({
                url: 'setting/list?region_type=service_recovery',
                params,
            }),
        }),
        regionAssignment: builder.query({
            query: (params) => ({
                url: 'v2/service-recovery/get-region-rule',
                params,
            }),
        }),
        tmpMgmt: builder.query({
            query: (params) => ({
                url: 'template/list',
                params,
            }),
        }),
        toggleTemplateStatus: builder.mutation({
            query: (payload) => ({
                url: "template/change-status",
                method: "POST",
                body: payload,
            }),
        }),
        toggleOverviewStatus: builder.mutation({
            query: (payload) => ({
                url: "v2/service-recovery/active-archive",
                method: "POST",
                body: payload,
            }),
        }),
        getOverviewTracking: builder.query({
            query: (params) => ({
                url: 'v2/service-recovery/tracking-list',
                params,
            }),
        }),
        v2DropdownList: builder.query({
            query: (params) => ({
                url: "v2/service-recovery/dropdown-list",
                method: "POST",
                params,
            }),
            keepUnusedDataFor: 60 * 60,
        }),
        getComplianceList: builder.query({
            query: (params) => ({
                url: 'v2/non-compliance/list',
                params,
            }),
        }),

    })
})

export const {
    useGetOverviewQuery,
    useGetStationSettingsQuery,
    useGetStationSettingsDetailQuery,
    useRegionsQuery,
    useRegionAssignmentQuery,
    useTmpMgmtQuery,
    useToggleTemplateStatusMutation,
    useToggleOverviewStatusMutation,
    useGetOverviewTrackingQuery,
    useV2DropdownListQuery,
    useGetComplianceListQuery
} = airlineService
